import { render, staticRenderFns } from "./AgreeDisagree.vue?vue&type=template&id=1fbdd6a0"
import script from "./AgreeDisagree.vue?vue&type=script&lang=ts"
export * from "./AgreeDisagree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports